export default __webpack_public_path__ + "static/media/intercom.faaa73db.svg";